import { combineReducers } from 'redux';

import auth from './auth/reducers';
import config from './config/reducers';
import masters from './masters/reducers';
import reports from './reports/reducers';
import transactions from './transactions/reducers';
import catchError from "./catchError";
import others from './others/reducers';

export const appReducer = combineReducers({
    auth,
    config,
    masters,
    reports,
    transactions,
    catchError,
    others,
})

const rootReducer = (state, action) => {
    return appReducer(state, action)
}

export default rootReducer;
